<template>
  <div>
    <div class="form-wrapper">
      <h2>Ad Set Setup</h2>

      <div class="form-group">
        <label class="tit" for="adSetName">
          Ad set name
          <span >*</span>
        </label>
        <input
          type="text"
          id="adSetName"
          placeholder="Type your ad set name"
          v-model="adSetName"
        />
      </div>

      <div class="form-group">
        <label class="tit">
          Performance goal
          <span >*</span>
        </label>
        <PreSelect
          v-model="performanceGoal"
          :options="performanceoptions"
          item-title="title"
          placeholder="select Performance goal"
          item-description="description"
          item-value="id"
        />
      </div>

      <div class="form-group">
        <label class="tit">
          When you are charged
          <span >*</span>
        </label>
        <v-select
          v-model="chargeType"
          :items="chargeOptions"
          variant="outlined"
          placeholder="select charge Type"
          density="compact"
          hide-details
          style="width: 100%"
        />
      </div>

      <div class="form-group switch">
        <label class="tit">Enable Bid Control</label>
        <input type="checkbox" id="enableBid" v-model="store.activeBid" />
        <label for="enableBid" class="toggle-label">
          <span class="circle"></span>
        </label>
      </div>

      <div class="form-group2" v-if="store.activeBid">
        <label>Bid Control <span class="required">*</span></label>
        <div class="budget-boxes mt-3">
          <div class="budget-card">
            <div class="platform-header">Set maximum bid for each platform</div>
            <div class="currency-input">
              <input type="number" v-model="store.bidamount" />
              <span>USD</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group switch">
        <label class="tit">Allow video download</label>
        <input type="checkbox" id="videoSharing" v-model="allowVideoSharing" />
        <label for="videoSharing" class="toggle-label">
          <span class="circle"></span>
        </label>
      </div>

      <div class="form-group switch">
        <label class="tit">Status <span class="required">*</span></label>
        <input type="checkbox" id="status" v-model="status" />
        <label for="status" class="toggle-label">
          <span class="circle"></span>
        </label>
        <span class="status-text">Active</span>
      </div>
    </div>

    <div class="form-wrapper Demographics mt-6">
      <h2>Demographics</h2>
      <div
        class="form-group"
        style="flex-direction: column; align-items: start"
      >
        <label class="tit">Location <span class="required">*</span></label>
        <p class="desc mb-8">Choose targeting locations for each platform</p>
        <Location ref="locationRef" />
      </div>

      <div class="form-group age-group flex">
        <label class="tit"
          >Age
          <span
      
            >*</span
          ></label
        >
        <div class="age-inputs flex justify-center align-center">
          <span>From</span>
          <v-select
            v-model="ageFrom"
            class="age"
            :items="ages"
            dense
            variant="outlined"
            hide-details
            style="max-width: 100px"
          ></v-select>

          <span>To</span>
          <v-select
            v-model="ageTo"
            class="age"
            :items="ages"
            dense
            variant="outlined"
            hide-details
            style="max-width: 100px"
          ></v-select>
        </div>
      </div>

      <div class="form-group">
        <label class="tit">Genders <span class="required">*</span></label>
        <div class="radio-row">
          <label v-for="g in genders" :key="g.value">
            <input
              type="radio"
              name="gender"
              :value="g.value"
              v-model="selectedGender"
            />
            {{ g.label }}
          </label>
        </div>
      </div>

      <div class="form-group">
        <label class="tit">Languages <span class="required">*</span></label>
        <v-select
          v-model="language"
          :items="languages"
          item-title="name"
          item-value="value"
          multiple
          variant="outlined"
          density="compact"
          placeholder="Select language(s)..."
          hide-details
          style="width: 100%"
        />
      </div>

      <div>
        <Audience
          :processed-countries-list="processedCountriesList"
          ref="audienceRef"
          class="mt-5"
        />
      </div>
    </div>

    <Placements class="mt-5" ref="placementsRef" />

    <div class="form-footer mt-5">
      <button type="button" class="btn-back" @click="$emit('prev')">
        back
      </button>
      <button type="button" class="btn-next" @click="validateAndProceed">
        Next
      </button>
    </div>

    <div v-if="errors.length" class="error-messages">
      <p
        v-for="(e, i) in errors"
        :key="i"
        class="error-text"
        style="color: red"
      >
        ⚠ {{ e }}
      </p>
    </div>
  </div>
</template>

<script>
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import Audience from "./StepTwo/Audience.vue";
import Placements from "./StepTwo/Placements.vue";
import apiClient from "@/core/buildRequest";
import PreSelect from "./PreSelect.vue";
import { useSuperAddStore } from "@/store/superAddStore";
import Location from "./StepTwo/Location.vue";

export default {
  name: "AdSetForm",
  components: {
    Treeselect,
    Audience,
    Placements,
    PreSelect,
    Location,
  },
  data() {
    return {
      store: useSuperAddStore(),
      errors: [],
      performanceoptions: [
        {
          id: "15s",
          title: "Maximize 15-second video views",
          description: "Reach users likely to watch 15 seconds.",
        },
        {
          id: "2s",
          title: "Maximize 2-second video views",
          description: "Reach users likely to watch 2 seconds.",
        },
      ],
      ages: Array.from({ length: 50 }, (_, i) => i + 17),
      genders: [
        { label: "All", value: "all" },
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
      ],
      languages: [],
    };
  },
  computed: {
    platforms() {
      return this.store.platforms;
    },
    adSetName: {
      get() {
        return this.store.adSetName;
      },
      set(val) {
        this.store.adSetName = val;
      },
    },
    performanceGoal: {
      get() {
        return this.store.performanceGoal;
      },
      set(val) {
        this.store.performanceGoal = val;
      },
    },
    chargeType: {
      get() {
        return this.store.chargeType;
      },
      set(val) {
        this.store.chargeType = val;
      },
    },
    allowVideoSharing: {
      get() {
        return this.store.allowVideoSharing;
      },
      set(val) {
        this.store.allowVideoSharing = val;
      },
    },
    status: {
      get() {
        return this.store.status;
      },
      set(val) {
        this.store.status = val;
      },
    },
    ageFrom: {
      get() {
        return this.store.ageFrom;
      },
      set(val) {
        this.store.ageFrom = val;
      },
    },
    ageTo: {
      get() {
        return this.store.ageTo;
      },
      set(val) {
        this.store.ageTo = val;
      },
    },
    selectedGender: {
      get() {
        return this.store.selectedGender;
      },
      set(val) {
        this.store.selectedGender = val;
      },
    },
    language: {
      get() {
        return this.store.language;
      },
      set(val) {
        this.store.language = val;
      },
    },
  },
  methods: {
    async fetchLanguages() {
      try {
        const response = await apiClient.get("/super-ad/languages");
        this.languages = response.data.data;
      } catch (error) {
        console.error("Error fetching languages", error);
      }
    },
    validateAndProceed() {
      this.errors = [];

      if (!this.adSetName.trim()) this.errors.push("Ad set name is required");
      if (!this.performanceGoal)
        this.errors.push("Performance goal is required");
      if (!this.chargeType) this.errors.push("Charge type is required");
      if (!Array.isArray(this.language) || this.language.length === 0) {
        this.errors.push("Please select at least one language.");
      }
      if (
        !this.ageFrom ||
        !this.ageTo ||
        Number(this.ageFrom) > Number(this.ageTo)
      )
        this.errors.push("Age range is invalid");

      if (this.store.activeBid) {
        const bid = this.store.bidamount;
        if (!bid || isNaN(Number(bid)) || Number(bid) <= 0) {
          this.errors.push("Bid amount must be a valid positive number.");
        }
      }

      const placementsError = this.$refs.placementsRef?.validate?.();
      if (placementsError) this.errors.push(placementsError);

      const locationError = this.$refs.locationRef?.validate?.();
      if (locationError) this.errors.push(locationError);

      const audienceError = this.$refs.audienceRef?.validate?.();
      if (audienceError) this.errors.push(audienceError);

      if (this.errors.length > 0) return;

      const data = {
        adSetName: this.adSetName,
        performanceGoal: this.performanceGoal,
        chargeType: this.chargeType,
        allowVideoSharing: this.allowVideoSharing,
        status: this.status,
        ageFrom: this.ageFrom,
        ageTo: this.ageTo,
        selectedGender: this.selectedGender,
        language: this.language,
      };

      const locationData = this.$refs.locationRef?.getData?.();
      if (locationData) Object.assign(data, locationData);

      const placementsData = this.$refs.placementsRef?.getData?.();
      if (placementsData) Object.assign(data, placementsData);

      const audienceData = this.$refs.audienceRef?.getData?.();
      if (audienceData) Object.assign(data, audienceData);

      this.store.setAdSetData(data);
      console.log("🚀 Final Payload", data);
      this.$emit("next");
    },
  },
  mounted() {
    this.fetchLanguages();
  },
};
</script>

<style scoped>
.form-wrapper {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: auto;
}

h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 1.5rem;
}
input {
  color: #333333 !important;
}
input[type="radio"] {
  accent-color: #207878;
}

.form-group {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.form-group2 {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}
.option-title {
  font-weight: 600;
  font-size: 14px;
  color: #237276;
}
.option-description {
  font-size: 13px;
  color: #666;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

input[type="text"],
select {
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100% !important;
  box-sizing: border-box;
}

.tit span {
  color: red !important;
  visibility: visible !important;
}

.desc {
  margin: 0.25rem 0 0.5rem;
  font-size: 0.875rem;
  color: #666;
}

.budget-boxes {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.budget-card {
  border: 1px solid #eee;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 200px;
  position: relative;
}

.platform-header {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  background: #f2f2f2;
  gap: 0.8rem;
  padding: 0.5rem;
  border-radius: 0.3rem;
}

.icon {
  width: 20px;
  height: 20px;
}

.currency {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  color: gray;
  font-size: 0.8rem;
}

.switch {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-direction: row;
}

input[type="checkbox"] {
  display: none;
}

.toggle-label {
  width: 40px;
  height: 22px;
  background: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

input[type="checkbox"]:checked + .toggle-label {
  background: #237276;
}

.toggle-label .circle {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 2px;
  left: 2px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s;
}

input[type="checkbox"]:checked + .toggle-label .circle {
  transform: translateX(18px);
}

.status-text {
  font-weight: 500;
}
.tit {
  min-width: 14rem;
}
/* age */
.age-group .age-inputs {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 16rem;
}

.age-inputs select {
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.radio-row {
  display: flex;
  gap: 2rem;
  margin-top: 0.5rem;
}

.radio-row label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

select {
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

.desc {
  font-size: 0.85rem;
  color: #777;
  margin-bottom: 0.5rem;
}

.location-input {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.location-input .icon {
  width: 20px;
  height: 20px;
}

.location-input input[type="text"] {
  flex: 1;
  padding: 0.65rem;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.v-field--variant-outlined .v-field__outline {
  display: none !important;
}
::v-deep(.v-field__outline) {
  display: none !important;
}
::v-deep(.v-input--horizontal) {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.25rem;
}
::v-deep(.v-text-field .v-field__outline) {
  display: none !important;
}
::v-deep(.v-field__field) {
  min-width: 5rem;
}
.age {
  max-width: 5.3rem !important;
  height: 3rem;
}
.form-footer {
  text-align: right;
  display: flex;
  gap: 0.8rem;
  justify-content: end;
}

.btn-next {
  background-color: #207878;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 6rem;
}
.btn-back {
  background-color: #f2f2f2;
  color: #4d4d4d;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 6rem;
}
.currency-input {
  display: flex;
  align-items: center;
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 14px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  font-size: 15px;
}

.currency-input input {
  flex: 1;
  border: none;
  outline: none;
  font-size: inherit;
  padding: 10px 0;
  background: transparent;
  min-width: 0;
  appearance: textfield;
}

.currency-input input::-webkit-outer-spin-button,
.currency-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.currency-input span {
  color: #555;
  white-space: nowrap;
  margin-left: 10px;
  font-weight: 500;
}
</style>
